import styled from "styled-components";


export const StyledTablePaginator = styled.div`
  display: flex;
  justify-content: end;
  align-items: center;
  background: #ffffff;
  box-shadow: 0px 1.30033px 5.20132px rgba(0, 0, 0, 0.12);
  border-radius: 5.20132px;
  padding: 0.5rem;
  .btns {
    display: flex;
    gap: 0.2rem;
    font-family: "Inter";
    font-style: normal;
    font-weight: 400;
    font-size: 15.9559px;
    button {
      /* background-color: red; */
      width: 25px;
      aspect-ratio: 1;
      cursor: pointer;
      font-family: "Inter";
      color: #5c6265;
    }
    .actv-btn {
      background: #ffffff;
      box-shadow: 0px 1.46287px 5.85148px rgba(26, 26, 67, 0.1);
      border-radius: 5.85148px;
    }
    .next {
      width: 25px;
      aspect-ratio: 1;
      background: #1AA5C0;
      border-radius: 5.85148px;
      text-align: center;
      color: white;
      cursor: pointer;
    }
  }
`;



export const StyledTableTooltipWrapper = styled.div`
  width: 100%;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const StyledSearchInputWrapper = styled.div`
  width: 555.36px;
  height: 53.54px;
  background: #ffffff;
  border: 1px solid #1AA5C0;
  border-radius: 8.7557px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  input {
    all: unset;
    width: 90%;
    border-style: none;
    height: 80%;
    font-size: 22px;
    padding: 10px;
  }
`;

export const StyledTableContainer = styled.table`
width: 100%;
border-collapse: collapse;
`;
export const StyledTableHeader = styled.tr`
background-color: #f1fbfc;
height: 55px;
border-radius: 10.6765px;
`;
export const StyledHeaderCell = styled.th`
  padding: 8px;
`;
export const StyledDataRow = styled.tr<{ isEven: boolean }>`
  background-color: ${(props) => (props.isEven ? "#f1fbfc" : "#e0ecf1")};
  height: 55px;
  border-radius: 16px;
  cursor: pointer;
  color: #858585;
`;
export const StyledDataCell = styled.td<{ isEmpty: boolean }>`
padding: 8px;
text-align: center;
justify-content: 'center';
font-weight:bold;
color:${(props) => (props.isEmpty ? 'red' : '#50799E')}
`;
